import { render, staticRenderFns } from "./DeniedView.vue?vue&type=template&id=c90e5c4c&"
import script from "./DeniedView.vue?vue&type=script&lang=js&"
export * from "./DeniedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports